export default __webpack_public_path__ + "static/media/martin.784d2793.png";